import React, { Component, ErrorInfo, ReactNode } from 'react';
import ErrorPage from '../../pages/ErrorPage/ErrorPage';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    // Atualiza o state para mostrar a UI de erro
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Log do erro técnico no console para debugging
    console.error('ErrorBoundary capturou um erro:', error);
    console.error('Informações do erro:', errorInfo);
    
    // Aqui você pode enviar o erro para um serviço de monitoramento
    // como Sentry, LogRocket, etc.
    this.logErrorToService(error, errorInfo);
    
    this.setState({
      error,
      errorInfo
    });
  }

  private logErrorToService = (error: Error, errorInfo: ErrorInfo) => {
    // Log detalhado para debugging
    const errorDetails = {
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href
    };

    console.group('🚨 Erro Capturado pelo ErrorBoundary');
    console.error('Erro:', error);
    console.error('Stack:', error.stack);
    console.error('Component Stack:', errorInfo.componentStack);
    console.error('Detalhes completos:', errorDetails);
    console.groupEnd();

    // TODO: Integrar com serviço de monitoramento
    // Exemplo: Sentry.captureException(error, { contexts: { react: errorInfo } });
    // Exemplo: LogRocket.captureException(error);
  };

  render() {
    if (this.state.hasError) {
      // Renderiza a página de erro customizada
      return (
        <ErrorPage 
          errorMessage="Ops! Algo deu errado"
          showDetails={false}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;